// utils/buildFilterParams.js

const fmtDate = (d) => {
  if (!d) return ""
  const date = d instanceof Date ? d : new Date(d)
  const dd = String(date.getDate()).padStart(2, "0")
  const mm = String(date.getMonth() + 1).padStart(2, "0")
  const yy = date.getFullYear()
  return `${dd}.${mm}.${yy}`
}

export const buildFilterParams = (applied, activeStatus) => {
  const f = {}

  // Поиск
  if (applied.search) f["filter[search]"] = applied.search
  if (applied.searchBy) f["filter[search_object]"] = applied.searchBy

  // Статусы — таб activeStatus имеет приоритет
  if (activeStatus) {
    f["filter[status_ids][]"] = [activeStatus]
  } else if (applied.status?.length) {
    f["filter[status_ids][]"] = applied.status
  }

  // Компании
  if (applied.sellers?.length) f["filter[company_id]"] = applied.sellers[0]
  if (applied.suppliers?.length) f["filter[partner_id]"] = applied.suppliers[0]

  // Пользователи
  if (applied.users?.length) f["filter[users][]"] = applied.users

  // Модератор
  if (applied.moderator) f["filter[moderator_id]"] = applied.moderator

  // Рынок
  if (applied.market?.length) f["filter[market_state_ids][]"] = applied.market

  // Страна
  if (applied.states) f["filter[state_id]"] = applied.states

  // Даты запросов
  if (applied.dateRequest?.from) f["filter[from_order]"] = fmtDate(applied.dateRequest.from)
  if (applied.dateRequest?.to) f["filter[to_order]"] = fmtDate(applied.dateRequest.to)

  // Даты заезда
  if (applied.dateCheckin?.from) f["filter[from_entry]"] = fmtDate(applied.dateCheckin.from)
  if (applied.dateCheckin?.to) f["filter[to_entry]"] = fmtDate(applied.dateCheckin.to)

  // Даты выезда
  if (applied.dateCheckout?.from) f["filter[from_exit]"] = fmtDate(applied.dateCheckout.from)
  if (applied.dateCheckout?.to) f["filter[to_exit]"] = fmtDate(applied.dateCheckout.to)

  // Модуль
  if (applied.modules) f["filter[module_id]"] = applied.modules

  // Услуги
  if (applied.services?.length) f["filter[service_ids][]"] = applied.services

  // Пакет
  if (applied.package?.length) f["filter[module_ids][]"] = applied.package

  // Referrer
  if (applied.referer?.length) f["filter[referer][]"] = applied.referer

  // Статус оплаты
  if (applied.paymentStatus) f["filter[payment_status]"] = applied.paymentStatus

  // Статус комнаты
  if (applied.roomStatus) f["filter[room_status]"] = applied.roomStatus

  // Направление
  if (applied.direction && applied.direction !== "any") {
    f["filter[order_direction]"] = applied.direction
  } else {
    f["filter[order_direction]"] = "all"
  }

  // Условия
  if (applied.condition?.deleted) f["filter[is_delete]"] = 1
  if (applied.condition?.archive) f["filter[is_archive]"] = 1
  if (applied.condition?.ticketsIssued) f["filter[transport_printed]"] = "yes"
  if (applied.condition?.ticketsNotIssued) f["filter[transport_no_printed]"] = "yes"
  if (applied.condition?.competitorPrice) f["filter[competitor_price_request]"] = 1

  return f
}
